/**
 * Desktop-only floating hint showing keyboard shortcuts. Hidden on
 * touch devices and on small viewports. Helps photographers preview
 * the experience on their laptop.
 */
export function KeyboardHint({
  hints,
}: {
  hints: { key: string; label: string }[];
}) {
  return (
    <div className="hidden md:flex absolute -left-56 top-1/2 -translate-y-1/2 flex-col gap-2 text-[11px] text-[var(--text-tertiary)]">
      <div className="text-[10px] uppercase tracking-wider text-[var(--text-quaternary)] mb-1">
        Keyboard
      </div>
      {hints.map((h) => (
        <div key={h.key} className="flex items-center gap-2">
          <kbd className="min-w-6 h-6 px-1.5 rounded-md bg-[var(--surface-secondary)] border border-[var(--border-default)] grid place-items-center text-[var(--text-secondary)] font-mono text-[10px]">
            {h.key}
          </kbd>
          <span>{h.label}</span>
        </div>
      ))}
    </div>
  );
}
